import { computed, inject, type ComputedRef } from 'vue'
import type { MenuContext } from './types'

export const useMenu = (): {
  context: ComputedRef<ReturnType<MenuContext>>
} => {
  const menuContext = inject<MenuContext>('menuContext', () => {
    return {
      activatedMenuItemId: '',
      isOpen: false,
      preventClose: false,
      menuListId: '',
      menuButtonId: '',
      activeIndex: -1,
      focusableCount: 0,
      closeMenu: (): void => {},
      openMenu: (): void => {},
      toggleMenu: (): void => {},
      focusOnFirstItem: (): void => {},
      focusOnLastItem: (): void => {},
      focusButton: (): void => {},
      handleKeydownOnList: (): void => {},
    }
  })

  return {
    context: computed(() => menuContext()),
  }
}
